// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5a713bfd","81":"7489075e","787":"25471cf6"}[chunkId] + ".chunk.js";
};